import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Users = lazy(() => import('./users'));

export function UsersPage() {
  return (
    <article className="space-y-6" data-testid="users-page">
      <Suspense fallback={<Loading />}>
        <Users />
      </Suspense>
    </article>
  );
}
